module.exports = __webpack_public_path__ + "9f106fb892f1ab3289bd8a837b409b98.png";